var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletarOracionPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow-3d",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 4.5,
    floodColor: "#0369A1",
    floodOpacity: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow-cyan",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBg",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pencilGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D97706"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 55,
    r: 30,
    fill: "#E0F2FE",
    filter: "blur(15px)",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 20) rotate(-4)",
    filter: "url(#shadow-3d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 84,
    height: 66,
    rx: 10,
    fill: "url(#cardBg)",
    stroke: "#0284C7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 78,
    height: 60,
    rx: 7,
    fill: "none",
    stroke: "#38BDF8",
    strokeWidth: 1.2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 5,
    x2: 30,
    y2: 5,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 5,
    x2: 52,
    y2: 5,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 18,
    x2: 14,
    y2: 18,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 32,
    height: 13,
    rx: 3.5,
    fill: "#E0F2FE",
    stroke: "#0284C7",
    strokeWidth: 1.5,
    strokeDasharray: "3 2",
    filter: "url(#glow-cyan)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 20.5,
    fontFamily: "system-ui, sans-serif",
    fontSize: 7.5,
    fontWeight: 900,
    fill: "#0369A1",
    textAnchor: "middle"
  }, "neje"), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 18,
    x2: 66,
    y2: 18,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 31,
    x2: 22,
    y2: 31,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 31,
    x2: 48,
    y2: 31,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 31,
    x2: 64,
    y2: 31,
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74, 52)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5.5,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.5,0 L-0.5,2 L 2.5,-2.5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58, 38) rotate(-35)",
    filter: "url(#shadow-3d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 4,-2 L 4,2 Z",
    fill: "#374151",
    stroke: "#78350F",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4,-2 L 10,-4 L 10,4 L 4,2 Z",
    fill: "#FDE047",
    stroke: "#78350F",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,-4 L 30,-4 L 30,4 L 10,4 Z",
    fill: "url(#pencilGrad)",
    stroke: "#78350F",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30,-4 L 34,-4 L 34,4 L 30,4 Z",
    fill: "#94A3B8",
    stroke: "#78350F",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34,-4 L 39,-4 L 39,4 L 34,4 Z",
    fill: "#F472B6",
    stroke: "#78350F",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletarOracionPremium);
export default __webpack_public_path__ + "static/media/completar_oracion_premium.5435943fbd90efe9595a6d9e8bebce91.svg";
export { ForwardRef as ReactComponent };